import { useNavigate } from "react-router-dom";
import { formatCurrencyIndian, WorkStatModal } from "../../CustomFunctions";
import React, { useState, useMemo } from "react";
import { Eye } from "lucide-react";
import { DeleteProject, UpdateProjectDetails } from "../ProjectDetailsCrud/ProjectDetailsCRUD";
import { toast } from "react-toastify";

// ✅ SectionFilter import removed — filter is now handled in RopewayPage

/* ─── natural-sort helper ─── */
const naturalCompare = (a = "", b = "") =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });

/* ─── Sort indicator icon ─── */
const SortIcon = ({ colKey, sortConfig }) => {
    const isActive = sortConfig.key === colKey;
    const dir      = sortConfig.direction;
    return (
        <span style={{
            display: "inline-flex",
            flexDirection: "column",
            gap: "1px",
            marginLeft: 5,
            verticalAlign: "middle",
            opacity: isActive ? 1 : 0.35,
            transition: "opacity 0.15s",
        }}>
            <svg width="7" height="5" viewBox="0 0 7 5">
                <path d="M3.5 0L7 5H0z"
                    fill={isActive && dir === "asc" ? "#2576bc" : "#9ca3af"} />
            </svg>
            <svg width="7" height="5" viewBox="0 0 7 5">
                <path d="M3.5 5L0 0H7z"
                    fill={isActive && dir === "desc" ? "#2576bc" : "#9ca3af"} />
            </svg>
        </span>
    );
};

const RopewaySections = ({ project, getProject, buffer, ProjectDetails, hideSector = false }) => {
    const navigate = useNavigate();

    const currentUrl = window.location.href;
    const urlParts   = currentUrl.split("/");
    const toggleshow = "Contractor";

    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen]   = useState(false);
    const [modalType, setModalType]       = useState("");
    const [expandedStages, setExpandedStages] = useState({});


    /* ─── sort state ─── */
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

    /* ─── Sort cycle: asc → desc → reset ─── */
    const handleSort = (key) => {
        setSortConfig((prev) => {
            if (prev.key !== key)           return { key, direction: "asc" };
            if (prev.direction === "asc")   return { key, direction: "desc" };
            if (prev.direction === "desc")  return { key: null, direction: null };
            return { key, direction: "asc" };
        });
    };

    /* ─── Sorted list ─── */
    const sortedSections = useMemo(() => {
        if (!project?.length) return project || [];
        if (!sortConfig.key || !sortConfig.direction) return project;
        return [...project].sort((a, b) => {
            let cmp = 0;
            if (sortConfig.key === "pr_code") {
                cmp = naturalCompare(
                    a.project_details_data?.pr_code || "",
                    b.project_details_data?.pr_code || ""
                );
            }
            return sortConfig.direction === "asc" ? cmp : -cmp;
        });
    }, [project, sortConfig]);

    const ViewAllProjectDetails = (project) => {
        navigate(`/${urlParts[3]}/ProjectAllDetails/`, {
            state: { project, toggleshow },
        });
    };

    const truncateText = (text, wordLimit = 10) => {
        if (!text) return "-";
        const words = text.split(' ');
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(' ') + '...';
    };

    const handleViewProjectName = (item) => {
        setSelectedItem(item);
        setModalType("project_name");
        setIsModalOpen(true);
    };

    const handleViewWorkstages = (workstages) => {
        setSelectedItem(workstages);
        setModalType("workstages_list");
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedItem(null);
        setModalType("");
    };

    const toggleStages = (id, e) => {
    e.stopPropagation();
    setExpandedStages((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    
    return (
    <>
      

      <style>{`
        .sec-wrap {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
          font-family: sans-serif;
        }

        .sec-thead th {
          padding: 9px 12px;
          text-align: left;
          font-size: 11px;
          font-weight: 500;
          color: #9ca3af;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          border-bottom: 0.5px solid #e5e7eb;
          background: #f9fafb;
          white-space: nowrap;
        }

        .sec-th-sort {
          cursor: pointer;
          user-select: none;
          transition: color 0.15s, background 0.15s;
        }
        .sec-th-sort:hover  { color: #374151; background: #f3f4f6; }
        .sec-th-sort.active { color: #1e40af; background: #eff6ff; }

        .sec-sort-badge {
          display: inline-block;
          font-size: 9px;
          font-weight: 700;
          padding: 1px 5px;
          border-radius: 3px;
          margin-left: 5px;
          background: #1e40af;
          color: #fff;
          vertical-align: middle;
          letter-spacing: 0.03em;
        }

        .sec-row {
          border-bottom: 0.5px solid #f3f4f6;
          cursor: pointer;
          transition: background 0.12s;
        }
        .sec-row:last-child { border-bottom: none; }
        .sec-row:hover { background: #f9fafb; }

        .sec-row td {
          padding: 10px 12px;
          vertical-align: middle;
          color: #111827;
        }

        .sec-sno { font-size: 11px; color: #9ca3af; }

        .sec-code {
          font-size: 11px;
          font-weight: 500;
          background: #1e40af;
          color: #fff;
          padding: 2px 7px;
          border-radius: 3px;
          letter-spacing: 0.04em;
          display: inline-block;
          white-space: nowrap;
        }

        .sec-name {
          font-weight: 500;
          font-size: 12px;
          color: #1e40af;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 160px;
        }

        .sec-section-name {
          font-size: 12px;
          color: #374151;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 180px;
        }

        .sec-cost { font-weight: 500; font-size: 12px; color: #111827; }
        .sec-cost-unit { font-size: 10px; color: #9ca3af; }

        .sec-tag {
          font-size: 10px;
          border: 0.5px solid #e5e7eb;
          border-radius: 3px;
          padding: 2px 7px;
          color: #6b7280;
          background: #fff;
          display: inline-block;
          white-space: nowrap;
        }

        .sec-stages { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }

        .sec-stage-pill {
          font-size: 10px;
          font-weight: 500;
          padding: 2px 7px;
          border-radius: 3px;
          border: 0.5px solid #e5e7eb;
          color: #374151;
          background: #f9fafb;
          white-space: nowrap;
        }

        .sec-stage-more {
          font-size: 10px;
          color: #1e40af;
          font-weight: 500;
          cursor: pointer;
          padding: 2px 6px;
          border-radius: 3px;
          background: #eff6ff;
          border: 0.5px solid #bfdbfe;
        }
        .sec-stage-more:hover { background: #dbeafe; }

        .sec-actions { display: flex; gap: 6px; align-items: center; justify-content: flex-end; }

        .sec-view-btn {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          display: flex;
          align-items: center;
        }

        .sec-empty { text-align: center; padding: 60px 20px; color: #9ca3af; }
        .sec-empty-text { font-size: 13px; font-weight: 500; margin-top: 8px; }

        .sec-outer {
          border: 0.5px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
          background: #fff;
        }
      `}</style>

      <div className="table-box scroll-container-table" style={{ height: "80vh" }}>
          <table className="sec-wrap">
            <thead className="sec-thead">
              <tr>
                <th style={{ width: 36 }}>No.</th>

                <th
                  className={`sec-th-sort${sortConfig.key === "pr_code" ? " active" : ""}`}
                  onClick={() => handleSort("pr_code")}
                  title="Click to sort by Project Code"
                >
                  Code
                  <SortIcon colKey="pr_code" sortConfig={sortConfig} />
                  {sortConfig.key === "pr_code" && sortConfig.direction && (
                    <span className="sec-sort-badge">
                      {sortConfig.direction === "asc" ? "A→Z" : "Z→A"}
                    </span>
                  )}
                </th>

                <th>Project Name</th>
                <th>Section Name</th>
                <th>Work Stages</th>
                <th>Length</th>
                <th>Cost (Lakhs)</th>
                <th>Location</th>
                <th>View</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>

            {buffer ? (
              <tbody>
                <tr>
                  <td colSpan={10}>
                    <div className="spinner-bgdatil" />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {!sortedSections?.length ? (
                  <tr>
                    <td colSpan={10}>
                      <div className="sec-empty">
                        <div className="sec-empty-text">No sections found</div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  sortedSections.map((i, index) => {
                    const stages = i.workstat || [];
                    const showAll = expandedStages[index];
                    const visibleStages = showAll ? stages : stages.slice(0, 2);
                    const hiddenCount = stages.length - 2;

                    return (
                      <tr
                        key={index}
                        className="sec-row"
                        onClick={() => handleViewProjectName(i)}
                      >
                        <td className="sec-sno">{index + 1}</td>

                        <td>
                          <span className="sec-code">
                            {i.project_details_data?.pr_code || "-"}
                          </span>
                        </td>

                        <td style={{ maxWidth: 180 }}>
                          <div className="sec-name">
                            {i.project_details_data?.project_name?.length > 30
                              ? i.project_details_data.project_name.slice(0, 30) + "…"
                              : i.project_details_data?.project_name || "-"}
                          </div>
                        </td>

                        <td style={{ maxWidth: 200 }}>
                          <div className="sec-section-name">
                            {i.section_name || "—"}
                          </div>
                        </td>

                        <td
                          style={{ minWidth: 140 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="sec-stages">
                            {visibleStages.map((ws, wi) => (
                              <span key={ws.id || wi} className="sec-stage-pill">
                                {ws.name || ws}
                              </span>
                            ))}
                            {hiddenCount > 0 && (
                              <button
                                className="sec-stage-more"
                                onClick={(e) => toggleStages(index, e)}
                              >
                                {showAll ? "less" : `+${hiddenCount}`}
                              </button>
                            )}
                          </div>
                        </td>

                        <td>
                          {(Number(i.length) || 0).toFixed(3)} KM
                        </td>

                        <td>
                          <div className="sec-cost">
                            ₹{formatCurrencyIndian(Number(i.section_cost / 100000).toFixed(2)) || 0}
                          </div>
                          <div className="sec-cost-unit">Lakhs</div>
                        </td>

                        <td>
                          <span className="sec-tag">{i.location || "—"}</span>
                        </td>

                        <td onClick={(e) => e.stopPropagation()}>
                          <button
                            className="sec-view-btn"
                            onClick={() => ViewAllProjectDetails(i)}
                            title="View Project Details"
                          >
                            <Eye />
                          </button>
                        </td>

                        <td onClick={(e) => e.stopPropagation()}>
                          <div className="sec-actions">
                            <UpdateProjectDetails
                              i={i}
                              getProject={getProject}
                              project={project}
                              ProjectDetails={ProjectDetails}
                              usedFor="Ropeway"
                            />
                            <DeleteProject i={i} getProject={getProject} />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            )}
          </table>
        </div>

      {modalType === "project_name" && (
        <WorkStatModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedItem.project_details_data}
          usedFor="project_name"
        />
      )}

      {modalType === "workstages_list" && (
        <WorkStatModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedItem}
          usedFor="workstages_list"
        />
      )}
    </>
  );
};

export default RopewaySections;